module.exports = __webpack_public_path__ + "static/icon_digitalisierung-93198671924ee13a496b28bcb3021290.png";